<script lang="ts" setup>
  import { toRef, toRefs } from 'vue';
  import TimePicker from './TimePicker.vue';
  import { useField } from 'vee-validate';
  import { InputWidthVariant } from '../InputWrapper/';
  import type { DatePickerProps } from '../DatePicker';

  export type TimePickerFieldProps = Omit<DatePickerProps, 'modelValue'> & {
    rules?: (value: string) => string | boolean;
  };

  const props = withDefaults(defineProps<TimePickerFieldProps>(), {
    rules: undefined,
    type: 'text',
    width: InputWidthVariant.FULL,
  });

  const {
    name: inputName,
    label,
    rules,
    ...rest
  } = toRefs<TimePickerFieldProps>(props);
  // workaround to keep reactivity on rest value from toRefs
  const inputProps = toRef(rest);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<string>(inputName!.value!, rules?.value, {
    label: label?.value,
  });
</script>

<template>
  <TimePicker
    v-bind="inputProps"
    :error="errorMessage as string"
    :label="label"
    :meta="meta"
    :loading="loading"
    :model-value="inputValue"
    :name="name"
    :placeholder="placeholder"
    @blur="handleBlur"
    @update:modelValue="handleChange"
  >
    <template #iconRight> <slot name="iconRight"></slot> </template>
  </TimePicker>
</template>
